import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import 'prop-types';
import * as React from 'react';

function useVisibility() {
  var invokeOnMount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isVisible = _React$useState2[0],
      setIsVisible = _React$useState2[1];

  var inspectedElement = React.useRef(null);

  var onScroll = function onScroll() {
    if (!inspectedElement.current) {
      setIsVisible(false);
      return;
    }

    var top = inspectedElement.current.getBoundingClientRect().top;
    setIsVisible(top + offset >= 0 && top - offset <= window.innerHeight);
  };

  React.useEffect(function () {
    if (invokeOnMount) onScroll();
    document.addEventListener("scroll", onScroll, true);
    return function () {
      return document.removeEventListener("scroll", onScroll, true);
    };
  });
  return [isVisible, inspectedElement];
}

export { useVisibility };
